<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headertoc01" class="chapter" epub:type="toc" id="toc" role="doc-toc">
<header id="headertoc01">
<h1 class="ctfm"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span><span aria-label="vii" class="page" id="pvii" role="doc-pagebreak"></span>Contents</h1>
</header>
<p class="tocfm" id="racknow"><a class="xref" href="#/wsutvmgoodplace0009#acknow">Acknowledgments</a></p>
<p class="tocf" id="rintro"><a class="xref" href="#/wsutvmgoodplace0010#intro">Introduction: Entering <i>The Good Place</i></a></p>
<p class="toc" id="rch01"><a class="xref" href="#/wsutvmgoodplace0011#ch01">1. Puppet Masters and Playthings: <i>The Good Place</i> as Sitcom Meta-Commentary</a></p>
<p class="toc" id="rch02"><a class="xref" href="#/wsutvmgoodplace0012#ch02">2. “Up to 104% Perfect”: Narrative and Visual Style</a></p>
<p class="toc" id="rch03"><a class="xref" href="#/wsutvmgoodplace0013#ch03">3. What We Owe to Each Other: <i>The Good Place</i>’s Political Commentary</a></p>
<p class="toc" id="rch04"><a class="xref" href="#/wsutvmgoodplace0014#ch04">4. Teach Me Tonight: <i>The Good Place</i>’s Pedagogy</a></p>
<p class="toc" id="rconc"><a class="xref" href="#/wsutvmgoodplace0015#conc">Conclusion: Whenever You’re Ready: The Multiple Meanings of <i>The Good Place</i></a></p>
<p class="tocbmf" id="rnotes"><a class="xref" href="#/wsutvmgoodplace0016#notes">Notes</a></p>
<p class="tocbm" id="rbiblio"><a class="xref" href="#/wsutvmgoodplace0017#biblio">Bibliography</a></p>
<p class="tocbm" id="rindex"><a class="xref" href="#/wsutvmgoodplace0018#index">Index</a></p>
<p class="tocbm" id="raubio"><a class="xref" href="#/wsutvmgoodplace0019#aubio">About the Author</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-tvmgoodplace-0008.vue?4406e651